

























































































import { Organizer } from 'inscreva-sse-models';
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';

import { Event } from '../models/event';
import { sessionStore } from '../store/session';
import EventInfoOptions from './EventInfoOptions.vue';

@Component({
  components: {
    EventInfoOptions,
  },
})
export default class StepCheckInComponent extends Vue {
  @Prop({ required: true })
  private event!: Event;

  get showEventPrice() {
    return this.event.extraInfo.uniquePrice && !this.event.extraInfo.freePass;
  }

  get userIsOrganizer(): boolean {
    return this.event.organizer?._id === sessionStore.session.user.publicKey;
  }

  @Emit()
  onUseUserAsOrganizar($event: any) {
    const { name, email, id, publicKey } = sessionStore.session.user;
    if ($event.target?.checked) {
      this.event.organizer = {
        name,
        email,
        id,
        publicKey,
        companyName: sessionStore.session.company.name,
        _id: sessionStore.session.user.publicKey,
      };
    } else {
      this.event.organizer = new Organizer();
    }
  }

  get isFreePass(): boolean {
    return this.event.extraInfo.freePass || false;
  }

  @Watch('isFreePass')
  onFreePassChanged() {
    if (this.isFreePass) {
      this.event.info.price = 0;
    }
  }
}
